export enum PaginationHeadersEnum {
  PAGINATION_TOTAL_HEADER = "x-pagination-total",
  PAGINATION_PAGE_HEADER = "x-pagination-page",
  PAGINATION_PAGESIZE_HEADER = "x-pagination-pagesize",
}
